import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  resultParte:[],
  dataNotFound: [],
  resultNotificacion: [],
  currentParte: {},
  newParte:[],
  newToca:[],
  resultTocas:[],
};
export const mutations = {
  GET_PARTES({ context }, partes) {
    state.listPartes = Object.assign({}, partes);
  },
  SAVE_TOCAS_P({ context }, toca) {
    state.newToca= Object.assign({}, toca);
  },
  SAVE_PARTES({ context }, parte) {
    state.newParte= Object.assign({}, parte);
  },
  EDIT_PARTE({ context }, dataParte) {
    state.dataParte = Object.assign({}, dataParte);
  },
  RESULT_PARTES({ context }, result_partes) {
    state.loading = false;
    if (result_partes) {
      let partes = [];
      Object.entries(result_partes).forEach(([key, val]) => {
        if (val.tipo_cedula == 1) val.tipo_cedula = "Estatal"
        if (val.tipo_cedula == 2) val.tipo_cedula = "Federal"
        if (val.tipo_cedula == 3) {
          val.num_cedula = "-"
          val.tipo_cedula = "-"
        }
        partes.push(val)
      });
      return (state.resultParte = partes);
    }
  },
  dataNotFound({ context }, data) {
    state.dataNotFound = data
  },
  SHOW_PARTE({ context }, data) {
    state.loading = false;
    state.currentParte = Object.assign({}, data);
  },
  DELETE_PARTE({ context }, deleteParte) {
    state.deleteParte = Object.assign({}, deleteParte);
  },
  DELETE_PARTE_TOCA({ context }, deleteParteToca) {
    state.deleteParteToca = Object.assign({}, deleteParteToca);
  },
  GET_TOKEN({ context }, parte) {
    state.token= Object.assign({}, parte);
  },
  ENVIA_NOTIFICACION({ context }, dataNotificacion) {
    state.dataNotificacion= Object.assign({}, dataNotificacion);
  },
  SAVE_NOTIFICACION({ context }, notificacion) {
    state.notificacion= Object.assign({}, notificacion);
  },
  GET_NOTIFICACIONES({ context }, parte_id) {
    state.resultNotificacion = Object.assign({}, parte_id);
  },
  SET_PARTE_TOCAS(state, tocas) {
    if (Array.isArray(tocas)) {
      state.resultTocas = tocas;
    } else if (tocas && Array.isArray(tocas.data)) {
      state.resultTocas = tocas.data;
    } else {
      state.resultTocas = [];
    }
  },
};
export const actions = {
  GET_PARTE({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getParte(id)
        .then(response => {
          // console.log('response',response.data.partes);
          commit("SET_LOADING", false);
          commit("SHOW_PARTE", response.data.partes);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  CONSULTAR_PARTES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.consultarParte(data)
        .then(response => {
          if (response.data.msg == 'No Data') {
            commit("DATA_NOT_FOUND", data);
          }
          commit("SET_LOADING", false);
          commit("RESULT_PARTES", response.data.partes);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_TOCAS_P({ commit }, toca) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.addToca(toca)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_TOCAS_P", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  ADD_MULTIPLE_TOCAS({ commit }, data) { //axios, mandar parametros para post
    console.log('data',data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.addMultplieTocasToParte(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_TOCAS_P", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_PARTES({ commit }, parte) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.addParte(parte)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_PARTES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_PARTE({ commit }, dataParte) { //axios, mandar parametros para post
    //console.log("store",role);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.editParte(dataParte)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_PARTE", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SHOW_PARTE({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.mostrarParte(id)
        .then(response => {
          let parte = response.data.parte
          commit("SET_LOADING", false);
          commit("SHOW_PARTE", parte)
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_PARTE({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.deleteParte(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_PARTE", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_PARTE_TOCA({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.deleteParteToca(data)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_PARTE_TOCA", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_TOKEN({ commit }, user) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getToken(user)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_TOKEN", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  ENVIA_NOTIFICACION({ commit }, dataNotificacion) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.sendNotificacion(dataNotificacion)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("ENVIA_NOTIFICACION", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_NOTIFICACION({ commit }, notificacion) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.saveNotificacion(notificacion)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_NOTIFICACION", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_NOTIFICACIONES({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getNotificaciones(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_NOTIFICACIONES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_FILE({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getFile(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_NOTIFICACIONES", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_TOCAS_BY_PARTE({ commit }, payload) {
    const parteId = typeof payload === 'object' ? payload.parte_id : payload;
    const page = typeof payload === 'object' ? (payload.page || 1) : 1;

    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getTocasByParte(parteId, page)
        .then(response => {
          commit("SET_LOADING", false);
          // console.log('response tocas',response.data.data.tocas);
          commit("SET_PARTE_TOCAS", response.data.data.tocas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  // CONFIRM_TOCA({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.confirmToca(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         commit("GET_TOCAS", response);//mandar a mutations
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },
  // CANCEL_TOCA({ commit }, data) { //axios, mandar parametros para post
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.cancelToca(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         commit("GET_TOCAS", response);//mandar a mutations
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },
};

export const getters = {//leer datos
  currentParte: state => state.currentParte,
  //dataNotFound: state => state.dataNotFound,
  resultPartes: state => state.resultParte,
  resultTocas: state => state.resultTocas,
  //newParte: state => state.newParte,
};
